import { handleAction } from '@mendeley-internal/lib-js-redux-actions';
import { getMyProfile } from '../actions/profile';

export default handleAction(getMyProfile, {
  next(state, { payload, payload: { id } }) {
    return {
      ...state,
      [id]: payload
    };
  }
}, {});



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/profiles.js